import {Box, Grid} from "@mui/material";
import styled from "@emotion/styled";
import { FIXED_HEADER_OFFSET } from "../../components/layouts/headerLayout";

export const Wrapper = styled(Grid)(() => ({
  padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px`,
  "@media (max-width: 900px)": {
    padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px`,
  },
}));

export const MainContainer = styled(Box)`
  padding: 40px;
  @media (max-width: 900px) {
    padding: 15px;
  }
`;

